import React from 'react';
import {
  Field,
} from 'formik';
import { numToLetter } from '~/commons/helpers';

const FieldsMultiSelect = ({
  qtnIndex: i,
  question: q,
  answeredSeq,
  isCorrect,
  correctAns: cAns,
  disabled = false,
}) => (
  <div>
    {/* answer */}
    {/* {q.choices.map((c, ii) => (
      <div key={ii} className="mb-2">
        <FormCheckGroup
          className="mb-2"
          name={`answers.${i}.answeredSeq`}
          type="checkbox"
          label={`${numToLetter(ii, true)}. ${c}`}
          value={ii.toString()}
          disabled={disabled}
        />
      </div>
    ))} */}
    {q.choices.map(({ c, ii }, jj) => {
      // Handle both string and object format for choices
      const choiceText = typeof c === 'string' ? c : c.text;
      const choiceImg = typeof c === 'object' ? c.img : null;

      return (
        <div key={ii} className="mb-2">
          <div className="row">
            <div className="col-auto pr-0" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Field name={`answers.${i}.answeredSeq`} value={ii.toString()}>
                {({ field, form }) => {
                  const checked = Array.isArray(field.value)
                    ? field.value.includes(ii.toString())
                    : false;
                  return (
                    <div
                      onClick={() => {
                        if (disabled) return;
                        const current = Array.isArray(field.value) ? field.value : [];
                        if (checked) {
                          const filtered = current.filter((v) => v !== ii.toString());
                          form.setFieldValue(field.name, filtered);
                        } else {
                          form.setFieldValue(field.name, [...current, ii.toString()]);
                        }
                      }}
                      style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '4px',
                        border: '2px solid #ff8c42',
                        backgroundColor: checked ? '#ff8c42' : 'transparent',
                        cursor: disabled ? 'default' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.2s ease',
                      }}
                    >
                      {checked && (
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      )}
                    </div>
                  );
                }}
              </Field>
              <label style={{
                color: '#ff8c42',
                fontWeight: 'bold',
                fontSize: '16px',
                cursor: disabled ? 'default' : 'pointer',
                userSelect: 'none',
              }}>
                {`${numToLetter(jj, true)}.`}
              </label>
            </div>
            <div className="col">
              <Field name={`answers.${i}.answeredSeq`} value={ii.toString()}>
                {({ field, form }) => {
                  const checked = Array.isArray(field.value)
                    ? field.value.includes(ii.toString())
                    : false;
                  return (
                    <label
                      className="form-check-label"
                      onClick={() => {
                        if (disabled) return;
                        const current = Array.isArray(field.value) ? field.value : [];
                        if (checked) {
                          const filtered = current.filter((v) => v !== ii.toString());
                          form.setFieldValue(field.name, filtered);
                        } else {
                          form.setFieldValue(field.name, [...current, ii.toString()]);
                        }
                      }}
                      style={{
                        cursor: disabled ? 'default' : 'pointer',
                        userSelect: 'none',
                      }}
                    >
                      {choiceText}
                      {choiceImg && (
                        <div className="mt-2">
                          <img
                            src={choiceImg}
                            alt={choiceText || `Choice ${jj + 1}`}
                            style={{
                              maxWidth: '100%',
                              height: 'auto',
                              display: 'block',
                            }}
                            className="img-fluid"
                          />
                        </div>
                      )}
                    </label>
                  );
                }}
              </Field>
            </div>
          </div>
        </div>
      );
    })}
    {/* answered */}
    {answeredSeq?.length > 0 && (
      <div className={`
        mt-3 py-2 px-4 position-relative
        ${
          cAns !== undefined && !isCorrect
            ? 'bg-light' : 'bg-quinary'
        }
      `}>
        我的答案:
        &nbsp;
        {answeredSeq
          .map((a) => {
            const choice = q.choices.find((c) => String(c.ii) === String(a));
            return choice ? q.choices.indexOf(choice) : -1;
          })
          .filter((index) => index !== -1)
          .sort()
          .map((a) => numToLetter(a, true))
          .join(', ')
        }
        {/* correct/incorrect mark */}
        {cAns !== undefined && (
          <img
            className="pos-abs-br mr-3 mb-2"
            {...isCorrect ? {
              src: '/assets/img/correct.svg',
              style: { width: '42px', height: '36px' },
            } : {
              src: '/assets/img/incorrect.svg',
              style: { width: '34px', height: '40px' },
            }}
          />
        )}
      </div>
    )}
    {/* correct answer */}
    {(cAns !== undefined && !isCorrect) && (
      <div className="text-tertiary mt-3 py-2 px-4">
        正確答案:
        &nbsp;
        {cAns
          .map((a) => {
            const choice = q.choices.find(({ ii }) => String(ii) === String(a));
            return choice ? numToLetter(q.choices.indexOf(choice), true) : null;
          })
          .filter((item) => item !== null)
          .sort()
          .join(', ')
        }
      </div>
    )}
  </div>
);

export default FieldsMultiSelect;
